/* ARCELF — interactions
   1) SP menu: hamburger → fade-in overlay (vanilla, no deps)
   2) Large images: scroll-driven zoom-out (1.14 → 1.0), Safari-safe rAF
   Safe by design: respects prefers-reduced-motion; if anything is missing
   the page renders fully (nothing is hidden by JS). */
(function () {
  'use strict';

  /* ============================================================
     1) SP hamburger menu — fade in / out
     ============================================================ */
  (function menu() {
    var header = document.querySelector('[data-arcelf-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-arcelf-menu-toggle]');
    if (!toggle) return;

    var setOpen = function (open) {
      header.classList.toggle('is-menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('arcelf-menu-locked', open);
    };

    toggle.addEventListener('click', function () {
      setOpen(!header.classList.contains('is-menu-open'));
    });

    header.querySelectorAll('.arcelf-header__nav a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    /* reset when leaving the SP breakpoint */
    var mq = window.matchMedia('(min-width: 750px)');
    var onChange = function () { if (mq.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  })();

  /* ============================================================
     2) Scroll-driven zoom-out on large editorial images
     ============================================================ */
  (function zoom() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var targets = Array.prototype.slice.call(
      document.querySelectorAll('.arcelf-fullimg__media img')
    );
    if (!targets.length) return;

    var MAX = 1.14, MIN = 1.0;
    var active = [];
    var ticking = false;

    var apply = function () {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < active.length; i++) {
        var img = active[i];
        var frame = img.parentElement;
        var rect = frame.getBoundingClientRect();
        /* progress: 0 as the frame enters from the bottom, 1 as it exits the top */
        var travel = vh + rect.height;
        var passed = vh - rect.top;
        var p = passed / travel;
        if (p < 0) p = 0; else if (p > 1) p = 1;
        var scale = MAX - (MAX - MIN) * p;
        img.style.transform = 'scale(' + scale.toFixed(4) + ')';
      }
    };

    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var idx = active.indexOf(e.target);
          if (e.isIntersecting && idx === -1) active.push(e.target);
          else if (!e.isIntersecting && idx > -1) active.splice(idx, 1);
        });
        apply();
      }, { rootMargin: '12% 0px 12% 0px' });
      targets.forEach(function (img) { io.observe(img); });
    } else {
      active = targets;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();
})();
